import {createReducer, PayloadAction} from '@reduxjs/toolkit';
import {BREAK_SETTINGS, BREAK_SETTINGS_LIST, USER_PREFERENCES} from './Actions';
import {BreakSettingsModel} from '../../types/requests/BreakSettingsModel';
import {UserPreferencesModel} from 'types/models/UserPreferencesModel';

export interface ISettingsState {
  breakSettingsListResultLoading: boolean;
  breakSettingsListResultError: string | undefined;
  breakSettingsListResult: BreakSettingsModel[] | undefined;
  breakSettingsLoading: boolean;
  breakSettingsRefreshing: boolean;
  breakSettingsSaving: boolean;
  breakSettingsSaveError: string | undefined;
  breakSettingsError: string | undefined;
  breakSettingsEditDetail: BreakSettingsModel | undefined;
  breakSettingsDetail: BreakSettingsModel | undefined;

  userPreferences: UserPreferencesModel | undefined;
  userPreferencesLoading: boolean;
  userPreferencesLoadingError: string | undefined;
  userPreferencesRefreshing: boolean;
  userPreferencesSaving: boolean;
  userPreferencesSaveError: string | undefined;
  userPreferencesInit: boolean;
}

const initialState: ISettingsState = {
  breakSettingsListResultLoading: false,
  breakSettingsListResultError: undefined,
  breakSettingsListResult: undefined,
  breakSettingsLoading: false,
  breakSettingsRefreshing: false,
  breakSettingsSaving: false,
  breakSettingsSaveError: undefined,
  breakSettingsError: undefined,
  breakSettingsEditDetail: undefined,
  breakSettingsDetail: undefined,

  userPreferences: undefined,
  userPreferencesLoading: false,
  userPreferencesLoadingError: undefined,
  userPreferencesRefreshing: false,
  userPreferencesSaving: false,
  userPreferencesSaveError: undefined,
  userPreferencesInit: false
};

const settingsReducer = createReducer(initialState, {
  [BREAK_SETTINGS_LIST.LOAD]: (state) => {
    state.breakSettingsListResultError = undefined;
    state.breakSettingsListResultLoading = true;
  },
  [BREAK_SETTINGS_LIST.REFRESH]: (state) => {
    state.breakSettingsListResultError = undefined;
  },
  [BREAK_SETTINGS_LIST.ERROR]: (state, action: PayloadAction<string>) => {
    state.breakSettingsListResultError = action.payload;
    state.breakSettingsListResultLoading = false;
  },
  [BREAK_SETTINGS_LIST.LOADED]: (state, action: PayloadAction<BreakSettingsModel[]>) => {
    state.breakSettingsListResult = action.payload;
    state.breakSettingsListResultLoading = false;
    state.breakSettingsListResultError = undefined;
  },
  [BREAK_SETTINGS.REFRESH]: (state) => {
    state.breakSettingsLoading = false;
    state.breakSettingsRefreshing = true;
    state.breakSettingsError = undefined;
    state.breakSettingsSaveError = undefined;
  },
  [BREAK_SETTINGS.SAVE]: (state) => {
    state.breakSettingsSaving = true;
    state.breakSettingsError = undefined;
    state.breakSettingsSaveError = undefined;
  },
  [BREAK_SETTINGS.SAVED]: (state, action: PayloadAction<BreakSettingsModel>) => {
    state.breakSettingsSaving = false;
    state.breakSettingsError = undefined;
    state.breakSettingsSaveError = undefined;
    state.breakSettingsDetail = action.payload;
  },
  [BREAK_SETTINGS.SAVE_ERROR]: (state, action: PayloadAction<string>) => {
    state.breakSettingsSaving = false;
    state.breakSettingsError = undefined;
    state.breakSettingsSaveError = action.payload;
  },

  [USER_PREFERENCES.REFRESH]: (state) => {
    state.userPreferencesLoading = false;
    state.userPreferencesRefreshing = true;
    state.userPreferencesLoadingError = undefined;
    state.userPreferencesSaveError = undefined;
  },
  [USER_PREFERENCES.SAVE]: (state) => {
    state.userPreferencesSaving = true;
    state.userPreferencesLoadingError = undefined;
    state.userPreferencesSaveError = undefined;
  },
  [USER_PREFERENCES.SAVED]: (state, action: PayloadAction<UserPreferencesModel>) => {
    state.userPreferencesSaving = false;
    state.userPreferencesLoadingError = undefined;
    state.userPreferencesSaveError = undefined;
    state.userPreferences = action.payload;
  },
  [USER_PREFERENCES.SAVE_ERROR]: (state, action: PayloadAction<string>) => {
    state.userPreferencesSaving = false;
    state.userPreferencesLoadingError = undefined;
    state.userPreferencesSaveError = action.payload;
  },
  [USER_PREFERENCES.LOAD]: (state) => {
    state.userPreferencesLoadingError = undefined;
    state.userPreferencesLoading = true;
  },
  [USER_PREFERENCES.LOAD_ERROR]: (state, action: PayloadAction<string>) => {
    state.userPreferencesLoadingError = action.payload;
    state.userPreferencesLoading = false;
  },
  [USER_PREFERENCES.LOADED]: (state, action: PayloadAction<UserPreferencesModel>) => {
    state.userPreferences = action.payload;
    state.userPreferencesLoading = false;
    state.userPreferencesLoadingError = undefined;
  },
  [USER_PREFERENCES.INIT]: (state) => {
    state.userPreferencesInit = true;
  }
});

export default settingsReducer;
